(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.eupersoninformation === "undefined") {
        jQuery.extend(sm.portal.vm, { eupersoninformation: {} });
    }

    function ExtractATO(personInformation){
        var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
        var dateOfBirth = moment(personInformation.DateOfBirth(), dateFormat).format('YYYY-MM-DD');

        return new smapi.community.PersonModel({
            SalutationID: personInformation.SalutationID(),
            GivenName: personInformation.FirstName(),
            MiddleName: personInformation.MiddleName(),
            Surname: personInformation.LastName(),
            PreferredGivenName: personInformation.PreferredName(),
            DateOfBirth: dateOfBirth,
            GenderID: personInformation.GenderID(),
            TaxID: sm.portal.utility.isNullOrEmpty(personInformation.TaxID()) ? null : personInformation.TaxID(),
            ID: personInformation.ID(),
            SuffixID: -1,
            CRMRankID: -1,
            LeadTypeID: -1
        });
    }

    jQuery.extend(true, sm.portal.vm.eupersoninformation, {
        ExtractATO: ExtractATO
    });

})(jQuery);